/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";
import type { MenuProps } from "antd";
import { Dropdown } from "antd";
// @ts-ignore
// import { setAccessToken } from '../../../auth/index.ts';
import "./styles.css";

import { useNavigate } from "react-router-dom";
import { getRedirectPath } from "../../../utils/comman";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../../../actions/user";

const BellIcon = (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 18H0V16H1V9.031C1 4.043 5.03 0 10 0C14.97 0 19 4.043 19 9.031V16H20V18ZM7.5 19H12.5C12.5 19.663 12.2366 20.2989 11.7678 20.7678C11.2989 21.2366 10.663 21.5 10 21.5C9.33696 21.5 8.70107 21.2366 8.23223 20.7678C7.76339 20.2989 7.5 19.663 7.5 19Z"
      fill="#48BA89"
    />
  </svg>
);

const SettingsIcon = (
  // this commented code is the svg for the settings icon
  // <svg
  //   width="24"
  //   height="24"
  //   viewBox="0 0 24 24"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <path
  //     d="M9.95405 2.21C11.303 1.92713 12.6958 1.92645 14.045 2.208C14.1349 2.80129 14.3574 3.36669 14.6958 3.86218C15.0343 4.35767 15.4801 4.7705 16 5.07C16.5196 5.37053 17.1002 5.55006 17.6987 5.59525C18.2973 5.64044 18.8983 5.55012 19.457 5.331C20.3753 6.35906 21.0709 7.56604 21.5 8.876C21.0314 9.25058 20.6532 9.72595 20.3935 10.2668C20.1338 10.8076 19.9993 11.4 20 12C20 13.264 20.586 14.391 21.502 15.124C21.0704 16.4329 20.3739 17.6389 19.456 18.667C18.8974 18.448 18.2966 18.3578 17.6983 18.403C17.0999 18.4482 16.5195 18.6276 16 18.928C15.4805 19.2274 15.0351 19.64 14.6968 20.1351C14.3585 20.6302 14.1361 21.1952 14.046 21.788C12.6973 22.0715 11.3044 22.0729 9.95505 21.792C9.86559 21.1982 9.64335 20.6322 9.30487 20.1361C8.96639 19.6401 8.52038 19.2268 8.00005 18.927C7.48041 18.6266 6.89975 18.4473 6.30124 18.4023C5.70272 18.3572 5.10176 18.4477 4.54305 18.667C3.62465 17.6386 2.92905 16.4313 2.50005 15.121C2.96844 14.7466 3.34651 14.2716 3.60618 13.7311C3.86586 13.1906 4.00048 12.5986 4.00005 11.999C4.00054 11.3989 3.86575 10.8064 3.60571 10.2655C3.34568 9.72466 2.96707 9.24938 2.49805 8.875C2.92972 7.56612 3.62616 6.3601 4.54405 5.332C5.1027 5.55096 5.70352 5.6412 6.30184 5.59601C6.90017 5.55082 7.48062 5.37138 8.00005 5.071C8.51959 4.7716 8.96503 4.35902 9.30331 3.86391C9.64158 3.36879 9.864 2.80384 9.95405 2.211V2.21ZM12 15C12.7957 15 13.5588 14.6839 14.1214 14.1213C14.684 13.5587 15 12.7956 15 12C15 11.2043 14.684 10.4413 14.1214 9.87868C13.5588 9.31607 12.7957 9 12 9C11.2044 9 10.4413 9.31607 9.87873 9.87868C9.31612 10.4413 9.00005 11.2043 9.00005 12C9.00005 12.7956 9.31612 13.5587 9.87873 14.1213C10.4413 14.6839 11.2044 15 12 15Z"
  //     fill="#48BA89"
  //   />
  // </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0002 13.6922C13.547 13.6922 14.9767 13.2563 16.1205 12.5156C17.0064 11.9484 18.1595 12.0422 18.9377 12.75C21.0986 14.7094 22.3267 17.4891 22.322 20.4094V21.6609C22.322 22.9547 21.272 24 19.9783 24H4.02203C2.72828 24 1.67828 22.9547 1.67828 21.6609V20.4094C1.6689 17.4938 2.89703 14.7094 5.05796 12.7547C5.83609 12.0469 6.9939 11.9531 7.87515 12.5203C9.02359 13.2563 10.4486 13.6922 12.0002 13.6922Z"
      fill="#48BA89"
    />
    <path
      d="M11.9999 11.6063C15.2049 11.6063 17.803 9.0081 17.803 5.80313C17.803 2.59815 15.2049 0 11.9999 0C8.79493 0 6.19678 2.59815 6.19678 5.80313C6.19678 9.0081 8.79493 11.6063 11.9999 11.6063Z"
      fill="#48BA89"
    />
  </svg>
);

const items: MenuProps["items"] = [
  {
    label: "Profile",
    key: "1",
  },
  {
    label: "Change Password",
    key: "2",
  },
  {
    label: "Logout",
    key: "3",
  },
];

const DropdownUser = ({
  userData,
  svgOptions,
}: {
  userData: any;
  svgOptions: string;
}) => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const user = useSelector((state: any) => state?.Auth?.user);

  const handleMenuClick: MenuProps["onClick"] = (e: any) => {
    if (Number(e.key) === 1) {
      // userData?.roleId !== 2 &&
      // const route = roleRoutes[roleId] || "/profile";
      // navigate("/admin/account/profile", {
      navigate("/profile", {
        state: { changePassword: false },
      });
    }
    if (Number(e.key) === 2) {
      // userData?.roleId !== 2 &&
      navigate("/password-change", {
        state: { changePassword: true },
      });
    }
    if (Number(e.key) === 3) {
      logout();
    }
  };

  // Logout function
  const logout = () => {
    dispatch(
      userLogout(() => {
        // window.location.href = getRedirectPath();
        navigate(getRedirectPath());
      })
    );
  };

  const getProfileRole = () => {
    switch (userData?.roleId) {
      case 1: {
        return "Super Admin";
      }
      case 2: {
        return "Manger Admin";
      }
      case 3: {
        return "User";
      }
      default: {
        return "";
      }
    }
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <>
      <Dropdown menu={menuProps}>
        <button className="btn user-menu-button">
          {svgOptions === "bell" ? BellIcon : SettingsIcon}
        </button>
      </Dropdown>
    </>
  );
};

export default DropdownUser;
